import { Box, Spinner, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

const AutomationInProgress = () => {
  return (
    <Box
      position="absolute"
      width="full"
      justifyContent="center"
      alignItems="center"
      style={{
        backdropFilter: 'blur(1px)',
        backgroundColor: 'rgba(255, 255, 255, 0.7)',
        top: '20px',
        bottom: '48px',
        zIndex: '1000',
      }}
    >
      <Box
        alignItems="center"
        border={{
          all: {
            width: 's1',
            style: 'solid',
            color: 'grey400',
          },
        }}
        borderRadius={{ all: 'abs016' }}
        width="s400"
        background="grey000White"
        padding="s24"
        gap="s16"
      >
        <Spinner size="s32" />
        <Box alignItems="center" gap="s4">
          <Text.Header3>
            {i18n.t('shift_management.coverage_section.automation.in_progress.title')}
          </Text.Header3>
          <Text.Normal>
            {i18n.t('shift_management.coverage_section.automation.in_progress.description')}
          </Text.Normal>
        </Box>
      </Box>
    </Box>
  )
}

export default AutomationInProgress
